


















































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

import EditableInput from '@/components/EditableInput.vue';

@Component({
  components:{
    EditableInput
  }
})
export default class MetaItem extends Vue {

  httpBusy = false;
  labelEditing = false;
  internalLabel = '';
  internalValueList:{key:string, value:string}[] = [];

  @Prop({ default: 0,  type: Number}) index!:number;
  @Prop({ default: '',  type: String}) label!:string;
  @Prop({ default: () => [],  type: Array}) valueList!:string[];
  @Prop({ default: false,  type: Boolean}) editMode!:boolean;
  @Prop({ default: false,  type: Boolean}) disabled!:boolean;
  

  @Watch('editMode')
  onNewEditMode(newVal:boolean, oldVal:boolean) {
    this.localValues();
  }

  async mounted() {
    this.localValues();
  }

  localValues() {
    this.internalLabel = `` + this.label;
    this.internalValueList = this.valueList.map(value => ({key:``+value, value:``+value}));
  }

  onItemUpdate() {
    this.$emit('item-updated', {
      index: this.index,
      label:this.internalLabel,
      valueList:this.internalValueList.map(item => item.value)
    })
  }

  onItemRemove() {
    this.$emit('item-removed', {
      index:this.index
    })
  }

  get tagsInputPlaceholder() {
    if(this.valueList.length === 0)
      return `enter one or more elements`
    else
      return ``;
  }

}

